/* eslint-disable @typescript-eslint/no-explicit-any */
import ComboBoxFormik from '@/common/components/form/ComboBoxFormik';
import InputFormik from '@/common/components/form/InputFormik';

interface Props {
  formik: any;
  rules: any;
  entryPercentageOptions: { value: string; label: string }[];
  installmentOptions: { value: string; label: string }[];
  baseValue: number;
}

export default function PixOrBoletoPayment({
  formik,
  rules,
  entryPercentageOptions,
  installmentOptions,
}: Props) {
  return (
    <>
      {entryPercentageOptions.length > 0 && (
        <ComboBoxFormik
          label="Percentual da entrada (%)"
          name="boletoOrPix.entryPercentage"
          options={entryPercentageOptions}
          placeholder="Selecione o percentual"
          onChange={(value) => {
            formik.setFieldValue('boletoOrPix.entryPercentage', String(value));
          }}
        />
      )}

      {rules.canInstallment && (
        <>
          <ComboBoxFormik
            label="Número de parcelas"
            name="boletoOrPix.installments"
            options={installmentOptions}
            placeholder="Selecione o número de parcelas"
            disabled={Number(formik.values.boletoOrPix.entryPercentage) === 100}
            onChange={(value) => {
              formik.setFieldValue('boletoOrPix.installments', parseFloat(String(value)) || 1);
            }}
          />

          {Number(formik.values.boletoOrPix.installments) > 1 && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Data da primeira parcela
              </label>
              <InputFormik
                type="date"
                name="boletoOrPix.nextDueDate"
                value={formik.values.boletoOrPix.nextDueDate || ''}
                onChange={formik.handleChange}
                min={new Date().toISOString().split('T')[0]}
                max={new Date(Date.now() + 9 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
              <div className="text-xs text-gray-500 mt-1">
                📅 Selecione nos próximos 10 dias
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
